export let templateImportDiagnosticDataDescription = "Mzw2ae";
export default {templateImportDiagnosticDataDescription};